import { Skeleton, SkeletonItem } from '../../../atoms';

import { SkeletonWrapper } from './components.styled';

export const BaseCountrySelectInputSkeleton = () => (
	<SkeletonWrapper>
		<Skeleton>
			<SkeletonItem height={56} />
		</Skeleton>
	</SkeletonWrapper>
);
